const ENV_SWITCH_VARS = {
  'sam-acc.dualinventive.com': {
    IDP_URL: 'https://acc1-auth.mtinfo3000.com',
    IDP_CLIENT_ID: 'c9ab59ae1fe9a5abe37c04a68176a1b4',
    IDP_REDIRECT_URL: 'https://sam-acc.dualinventive.com/v2/',
    APP_BASE_URL: 'https://sam-acc.dualinventive.com/',
    FOTA_CERT_PATH: 'certs/fota-ca-dta.crt',
  },
  'sam-tst.dualinventive.com': {
    IDP_URL: 'https://tst01-auth.dualinventive.io',
    IDP_CLIENT_ID: 'c9ab59ae1fe9a5abe37c04a68176a1b4',
    IDP_REDIRECT_URL: 'https://sam-tst.dualinventive.com/v2/',
    APP_BASE_URL: 'https://sam-tst.dualinventive.com/',
    FOTA_CERT_PATH: 'certs/fota-ca-dta.crt',
  },
  'sam-dev.dualinventive.com': {
    IDP_URL: 'https://dev01-auth.dualinventive.io',
    IDP_CLIENT_ID: 'c9ab59ae1fe9a5abe37c04a68176a1b4',
    IDP_REDIRECT_URL: 'https://sam-dev.dualinventive.com/v2/',
    APP_BASE_URL: 'https://sam-dev.dualinventive.com/',
    FOTA_CERT_PATH: 'certs/fota-ca-dta.crt',
  },
  'sam.dualinventive.com': {
    IDP_URL: 'https://auth.mtinfo3000.com',
    IDP_CLIENT_ID: 'c9ab59ae1fe9a5abe37c04a68176a1b4',
    IDP_REDIRECT_URL: 'https://sam.dualinventive.com/v2/',
    APP_BASE_URL: 'https://sam.dualinventive.com/',
    FOTA_CERT_PATH: 'certs/fota-ca-prd.crt',
  },
  'localhost:3000': {
    IDP_URL: 'https://dev01-auth.dualinventive.io',
    IDP_CLIENT_ID: 'c9ab59ae1fe9a5abe37c04a68176a1b4',
    IDP_REDIRECT_URL: 'http://localhost:3000',
    SAM_BACKEND_URL: 'http://localhost:8080',
    SAM_FOTA_BACKEND_URL: 'http://localhost:8082',
    APP_BASE_URL: 'http://localhost:3000/v2/',
    LOCAL_FRONT_LOCAL_BACKEND: true,
    FOTA_CERT_PATH: 'certs/fota-ca-dta.crt',
  },
  default: {
    IDP_URL: 'https://dev01-auth.dualinventive.io',
    IDP_CLIENT_ID: 'c9ab59ae1fe9a5abe37c04a68176a1b4',
    IDP_REDIRECT_URL: 'https://sam-dev.dualinventive.com/v2/',
    // IDP_REDIRECT_URL: 'http://localhost:3000/',
    // SAM_BACKEND_URL: 'http://localhost:8080',
    // SAM_FOTA_BACKEND_URL: 'http://localhost:8082',
    LOCAL_FRONT_LOCAL_BACKEND: false,
    FOTA_CERT_PATH: 'certs/fota-ca-dta.crt',
  },
}

function getEnvironmentConfig() {
  const hostname = window.location.hostname
  const port = window.location.port
  const hostWithPort = port ? `${hostname}:${port}` : hostname

  return (
    ENV_SWITCH_VARS[hostWithPort] ||
    ENV_SWITCH_VARS[hostname] ||
    ENV_SWITCH_VARS.default
  )
}

export const APP_CONFIG = getEnvironmentConfig()
